import axios from "./axios";

export const getUserElements = async () => {
  const response = await axios.get("/user-elements");
  return response.data;
};

export const getUserElementCategories = async () => {
  const response = await axios.get("/user-elements/categories");
  return response.data;
};

export const getUserElementsByCategory = async (categoryId) => {
  const response = await axios.get(`/user-elements/category/${categoryId}`);
  return response.data;
};

export const getUserElementsBySubcategory = async (subcategoryId) => {
  const response = await axios.get(`/user-elements/subcategory/${subcategoryId}`);
  return response.data;
};

export const uploadUserElement = async (categoryId, file, name = '', price = 0) => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('categoryId', categoryId);
  if (name) formData.append('name', name);
  formData.append('price', price);
  
  const response = await axios.post('/user-elements', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return response.data;
};

export const updateUserElement = async (id, data) => {
  const response = await axios.patch(`/user-elements/${id}`, data);
  return response.data;
};

export const deleteUserElement = async (id) => {
  const response = await axios.delete(`/user-elements/${id}`);
  return response.data;
};

export const getUserElementsInfo = async (elementIds) => {
  const response = await axios.post('/user-elements/info', { elementIds });
  return response.data;
};
